export default {
  en: {
    'components.reset-password-form.password.label': 'New password',
    'components.reset-password-form.password.placeholder': 'Enter a new password',
    'components.reset-password-form.password.required': 'Please enter a new password',

    'components.reset-password-form.confirm-password.label': 'Confirm password',
    'components.reset-password-form.confirm-password.placeholder': 'Confirm new password',
    'components.reset-password-form.confirm-password.required': 'Please confirm password',
    'components.reset-password-form.password.no-match': 'Passwords do not match',

    'components.reset-password-form.action.reset': 'Reset',

    'components.reset-password-form.response.invalid': 'Password change token is invalid.',
    'components.reset-password-form.response.success': 'Password changed successfully.',
    'components.reset-password-form.response.failure': 'Password change failed.',
  },
};
